import {
  EventEmitter
} from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

class ProjectsService extends EventEmitter {
  TC_API_BASE_URL = process.env.VUE_APP_API_URL + "/";

  cloneProject(query) {
    var url = "/api/Projects/Clone";
    return TCVelikClient.PostRelative(url, query);
  }

  getProjects(userId, filters, skip, take, simpleOnly) {
    if (!skip)
      skip = 0;
    if (!take)
      take = 20;

    if (!simpleOnly)
      simpleOnly = false;

    var url = `/api/Projects/Get?userId=${userId}&filter=${filters}&skip=${skip}&take=${take}&simpleViewOnly=${simpleOnly}`;
    return TCVelikClient.GetRelative(url);
  }

  getProject(projectId) {
    var url = "/api/Projects/GetDetails?projectId=" + projectId + "&userId=" + TCVelikClient.getUserId();
    return TCVelikClient.GetRelative(url);
  }

  indexProject(payload) {
    var url = "/api/Projects/Index";
    return TCVelikClient.PostRelative(url, payload);
  }

  indexAllProjects(bFullScan) {
    var url = "/api/Projects/IndexAll?fullIndex=" + bFullScan;
    return TCVelikClient.GetRelative(url);
  }

  deleteProject(id) {
    var url = "/api/Projects/Delete";
    var query = {
      ProjectId: id
    };
    return TCVelikClient.PostRelative(url, query);
  }

  changeGitCredentials(id, username, password, defaultBranch, repoUrl) {
    var url = "/api/Projects/ChangeRepoCredentials";
    var query = {
      ProjectId: id,
      Username: username,
      Password: password,
      DefaultBranch: defaultBranch,
      Url: repoUrl
    }
    return TCVelikClient.PostRelative(url, query);
  }
  getLatest(id) {
    var url = "/api/Projects/GetLatest";
    var query = {
      ProjectId: id,
    }
    return TCVelikClient.PostRelative(url, query);
  }

  showHistory(project) {
    var query = {
      "ProjectId": project.Id
    }
    return TCVelikClient.PostRelative("/api/Projects/GetHistory", query);
  }

  indexAllHistory(project){
    var query = {
      "ProjectId": project.Id
    }
    return TCVelikClient.PostRelative("/api/Projects/ReindexHistory", query);
  }

  discoverExercises() {
    return TCVelikClient.GetRelative("/api/Projects/DiscoverExercises");
  }

  updateProject(project) {
    return TCVelikClient.PostRelative("/api/Projects/Update", project);
  }
}

export default new ProjectsService();
